/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Task_Completed_Holder_TitleInputs */

const en_notifications_task_completed_holder_title = /** @type {(inputs: Notifications_Task_Completed_Holder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task completed on your case`)
};

const pt_br2_notifications_task_completed_holder_title = /** @type {(inputs: Notifications_Task_Completed_Holder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade concluída no seu caso`)
};

/**
* | output |
* | --- |
* | "Task completed on your case" |
*
* @param {Notifications_Task_Completed_Holder_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_completed_holder_title = /** @type {((inputs?: Notifications_Task_Completed_Holder_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Completed_Holder_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_completed_holder_title(inputs)
	return pt_br2_notifications_task_completed_holder_title(inputs)
});